<template>
  <svg
    width="179"
    height="155"
    viewBox="0 0 179 155"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#mask-icon-balloons7)">
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M27.1991 27.6091H26.4888V31.6319H27.1991V27.6091Z"
          fill="#47E6B1"
        />
        <path
          opacity="0.5"
          d="M28.8545 29.9754V29.2655H24.8295V29.9754H28.8545Z"
          fill="#47E6B1"
        />
      </g>
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M52.4451 115.16H51.7349V119.183H52.4451V115.16Z"
          fill="#47E6B1"
        />
        <path
          opacity="0.5"
          d="M54.1021 117.526V116.817H50.0771V117.526H54.1021Z"
          fill="#47E6B1"
        />
      </g>
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M17.1048 68.4297H16.3945V72.4524H17.1048V68.4297Z"
          fill="#47E6B1"
        />
        <path
          opacity="0.5"
          d="M18.7603 70.7959V70.0861H14.7353V70.7959H18.7603Z"
          fill="#47E6B1"
        />
      </g>
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M141.458 0H140.748V4.02273H141.458V0Z"
          fill="#47E6B1"
        />
        <path
          opacity="0.5"
          d="M143.114 2.36627V1.65637L139.089 1.65637V2.36627H143.114Z"
          fill="#47E6B1"
        />
      </g>
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M21.6053 10.0048H20.895V14.0275H21.6053V10.0048Z"
          fill="#47E6B1"
        />
        <path
          opacity="0.5"
          d="M23.2607 12.371V11.6611H19.2358V12.371H23.2607Z"
          fill="#47E6B1"
        />
      </g>
      <path
        opacity="0.5"
        d="M35.2157 100.803C35.0201 100.717 34.8627 100.563 34.7734 100.369C34.6841 100.176 34.6692 99.9559 34.7315 99.7519C34.7416 99.7207 34.748 99.6885 34.7507 99.6559C34.7651 99.5592 34.7457 99.4605 34.6958 99.3763C34.646 99.2921 34.5687 99.2277 34.477 99.1937C34.3852 99.1597 34.2846 99.1583 34.1919 99.1896C34.0992 99.221 34.0201 99.2833 33.9679 99.366C33.9483 99.3924 33.9319 99.4211 33.9189 99.4513C33.8335 99.6468 33.6791 99.8041 33.4853 99.8933C33.2914 99.9826 33.0714 99.9975 32.8673 99.9352C32.8361 99.9251 32.8039 99.9187 32.7713 99.916C32.6745 99.9017 32.5757 99.9211 32.4915 99.9709C32.4073 100.021 32.3428 100.098 32.3088 100.19C32.2748 100.281 32.2734 100.382 32.3048 100.475C32.3362 100.567 32.3985 100.646 32.4812 100.698C32.5077 100.718 32.5363 100.734 32.5665 100.747C32.7622 100.833 32.9196 100.987 33.0089 101.181C33.0981 101.375 33.113 101.594 33.0507 101.798C33.0407 101.83 33.0342 101.862 33.0315 101.894C33.0172 101.991 33.0366 102.09 33.0864 102.174C33.1363 102.258 33.2135 102.323 33.3053 102.357C33.397 102.391 33.4977 102.392 33.5904 102.361C33.6831 102.329 33.7621 102.267 33.8143 102.184C33.8339 102.158 33.8504 102.129 33.8634 102.099C33.9488 101.903 34.1031 101.746 34.297 101.657C34.4909 101.568 34.7108 101.553 34.915 101.615C34.9461 101.625 34.9783 101.632 35.0109 101.634C35.1077 101.649 35.2065 101.629 35.2907 101.579C35.3749 101.53 35.4394 101.452 35.4735 101.361C35.5075 101.269 35.5089 101.168 35.4775 101.076C35.4461 100.983 35.3838 100.904 35.301 100.852C35.2746 100.832 35.246 100.816 35.2157 100.803Z"
        fill="#4D8AF0"
      />
      <path
        opacity="0.5"
        d="M31.697 139.037C31.5014 138.952 31.3439 138.797 31.2547 138.604C31.1654 138.41 31.1505 138.19 31.2128 137.986C31.2229 137.955 31.2293 137.923 31.232 137.89C31.2463 137.793 31.2269 137.695 31.1771 137.611C31.1273 137.526 31.05 137.462 30.9582 137.428C30.8665 137.394 30.7658 137.393 30.6731 137.424C30.5805 137.455 30.5014 137.518 30.4492 137.6C30.4296 137.627 30.4131 137.655 30.4001 137.686C30.3151 137.881 30.1613 138.038 29.9679 138.128C29.7744 138.218 29.5548 138.233 29.3507 138.172C29.3195 138.162 29.2873 138.155 29.2547 138.152C29.1579 138.138 29.0591 138.157 28.9749 138.207C28.8907 138.257 28.8262 138.334 28.7922 138.426C28.7582 138.518 28.7568 138.618 28.7882 138.711C28.8196 138.804 28.8819 138.883 28.9646 138.935C28.9911 138.954 29.0197 138.971 29.0499 138.984C29.2456 139.069 29.403 139.223 29.4922 139.417C29.5815 139.611 29.5964 139.831 29.5341 140.035C29.5241 140.066 29.5176 140.098 29.5149 140.131C29.5006 140.227 29.52 140.326 29.5698 140.41C29.6197 140.494 29.6969 140.559 29.7887 140.593C29.8804 140.627 29.9811 140.628 30.0738 140.597C30.1665 140.566 30.2455 140.503 30.2977 140.421C30.3173 140.394 30.3338 140.366 30.3468 140.335C30.4322 140.14 30.5865 139.982 30.7804 139.893C30.9743 139.804 31.1942 139.789 31.3984 139.851C31.4295 139.861 31.4617 139.868 31.4943 139.871C31.5911 139.885 31.6899 139.866 31.7741 139.816C31.8583 139.766 31.9228 139.689 31.9568 139.597C31.9908 139.505 31.9923 139.405 31.9609 139.312C31.9295 139.219 31.8672 139.14 31.7844 139.088C31.7574 139.068 31.7281 139.051 31.697 139.037Z"
        fill="#4D8AF0"
      />
      <path
        opacity="0.5"
        d="M161.17 54.4053C160.974 54.3199 160.817 54.1657 160.727 53.9719C160.638 53.7781 160.623 53.5583 160.685 53.3543C160.695 53.3231 160.702 53.291 160.705 53.2583C160.719 53.1616 160.7 53.0629 160.65 52.9787C160.6 52.8946 160.523 52.8301 160.431 52.7961C160.339 52.7621 160.238 52.7607 160.146 52.7921C160.053 52.8234 159.974 52.8857 159.922 52.9684C159.902 52.9949 159.886 53.0235 159.873 53.0537C159.788 53.2491 159.634 53.4066 159.441 53.4962C159.247 53.5858 159.027 53.6013 158.823 53.5397C158.792 53.5297 158.76 53.5233 158.727 53.5206C158.631 53.5062 158.532 53.5256 158.448 53.5754C158.363 53.6252 158.299 53.7025 158.265 53.7942C158.231 53.8859 158.229 53.9865 158.261 54.0791C158.292 54.1717 158.355 54.2508 158.437 54.3029C158.464 54.3225 158.492 54.339 158.523 54.352C158.718 54.4373 158.876 54.5916 158.965 54.7853C159.054 54.9791 159.069 55.1989 159.007 55.403C158.997 55.4341 158.99 55.4663 158.988 55.4989C158.973 55.5956 158.993 55.6944 159.042 55.7785C159.092 55.8627 159.17 55.9272 159.261 55.9611C159.353 55.9951 159.454 55.9965 159.546 55.9652C159.639 55.9338 159.718 55.8715 159.77 55.7888C159.79 55.7624 159.806 55.7338 159.819 55.7035C159.905 55.508 160.059 55.3507 160.253 55.2615C160.447 55.1723 160.667 55.1574 160.871 55.2196C160.902 55.2297 160.934 55.2361 160.967 55.2388C161.064 55.2531 161.163 55.2338 161.247 55.1839C161.331 55.1341 161.395 55.0569 161.429 54.9652C161.463 54.8735 161.465 54.7729 161.434 54.6803C161.402 54.5876 161.34 54.5086 161.257 54.4564C161.23 54.436 161.201 54.4188 161.17 54.4053Z"
        fill="#4D8AF0"
      />
      <path
        opacity="0.5"
        d="M155.309 94.7681C155.113 94.6827 154.956 94.5285 154.867 94.3347C154.777 94.1409 154.763 93.9211 154.825 93.7171C154.835 93.6859 154.841 93.6538 154.844 93.6211C154.858 93.5244 154.839 93.4257 154.789 93.3415C154.739 93.2574 154.662 93.1929 154.57 93.1589C154.478 93.1249 154.378 93.1235 154.285 93.1549C154.192 93.1862 154.113 93.2485 154.061 93.3312C154.042 93.3577 154.025 93.3863 154.012 93.4165C153.927 93.612 153.772 93.7693 153.579 93.8586C153.385 93.9478 153.165 93.9627 152.961 93.9004C152.929 93.8904 152.897 93.8839 152.865 93.8812C152.768 93.8669 152.669 93.8863 152.585 93.9361C152.501 93.9859 152.436 94.0631 152.402 94.1548C152.368 94.2465 152.367 94.3471 152.398 94.4398C152.429 94.5324 152.492 94.6114 152.574 94.6636C152.601 94.6832 152.63 94.6996 152.66 94.7126C152.855 94.798 153.013 94.9522 153.102 95.146C153.191 95.3398 153.206 95.5596 153.144 95.7636C153.134 95.7948 153.127 95.8269 153.125 95.8596C153.11 95.9563 153.13 96.055 153.18 96.1392C153.23 96.2233 153.307 96.2878 153.399 96.3218C153.49 96.3558 153.591 96.3572 153.684 96.3258C153.776 96.2945 153.855 96.2322 153.908 96.1495C153.927 96.123 153.944 96.0944 153.957 96.0642C154.042 95.8687 154.196 95.7114 154.39 95.6221C154.584 95.5329 154.804 95.518 155.008 95.5803C155.039 95.5903 155.072 95.5968 155.104 95.5995C155.201 95.6138 155.3 95.5944 155.384 95.5446C155.468 95.4948 155.533 95.4176 155.567 95.3259C155.601 95.2342 155.602 95.1336 155.571 95.0409C155.539 94.9483 155.477 94.8693 155.394 94.8171C155.368 94.7975 155.339 94.7811 155.309 94.7681Z"
        fill="#4D8AF0"
      />
      <path
        opacity="0.5"
        d="M159.676 14.3279C159.48 14.2425 159.323 14.0883 159.233 13.8945C159.144 13.7007 159.129 13.4809 159.191 13.2769C159.202 13.2458 159.208 13.2136 159.211 13.181C159.225 13.0842 159.206 12.9855 159.156 12.9013C159.106 12.8172 159.029 12.7527 158.937 12.7187C158.845 12.6847 158.745 12.6833 158.652 12.7147C158.559 12.746 158.48 12.8083 158.428 12.891C158.408 12.9175 158.392 12.9461 158.379 12.9763C158.293 13.1718 158.139 13.3291 157.945 13.4184C157.751 13.5076 157.531 13.5225 157.327 13.4602C157.296 13.4502 157.264 13.4437 157.231 13.441C157.134 13.4267 157.036 13.4461 156.952 13.4959C156.867 13.5457 156.803 13.6229 156.769 13.7146C156.735 13.8064 156.733 13.9069 156.765 13.9996C156.796 14.0922 156.858 14.1712 156.941 14.2234C156.968 14.243 156.996 14.2594 157.027 14.2724C157.222 14.3578 157.38 14.512 157.469 14.7058C157.558 14.8996 157.573 15.1194 157.511 15.3234C157.501 15.3546 157.494 15.3867 157.492 15.4194C157.477 15.5161 157.497 15.6148 157.546 15.699C157.596 15.7831 157.674 15.8476 157.765 15.8816C157.857 15.9156 157.958 15.917 158.05 15.8856C158.143 15.8543 158.222 15.792 158.274 15.7093C158.294 15.6828 158.31 15.6542 158.323 15.624C158.409 15.4285 158.563 15.2712 158.757 15.1819C158.951 15.0927 159.171 15.0778 159.375 15.1401C159.406 15.1501 159.438 15.1566 159.471 15.1593C159.568 15.1736 159.666 15.1542 159.751 15.1044C159.835 15.0546 159.899 14.9774 159.933 14.8857C159.967 14.794 159.969 14.6934 159.937 14.6007C159.906 14.5081 159.844 14.4291 159.761 14.3769C159.735 14.3573 159.706 14.3409 159.676 14.3279Z"
        fill="#4D8AF0"
      />
      <path
        opacity="0.5"
        d="M173.373 119.226C173.177 119.14 173.02 118.986 172.931 118.792C172.841 118.598 172.826 118.379 172.889 118.175C172.899 118.143 172.905 118.111 172.908 118.079C172.922 117.982 172.903 117.883 172.853 117.799C172.803 117.715 172.726 117.65 172.634 117.616C172.542 117.582 172.442 117.581 172.349 117.612C172.256 117.644 172.177 117.706 172.125 117.789C172.106 117.815 172.089 117.844 172.076 117.874C171.991 118.07 171.836 118.227 171.642 118.316C171.449 118.405 171.229 118.42 171.025 118.358C170.993 118.348 170.961 118.341 170.929 118.339C170.832 118.324 170.733 118.344 170.649 118.394C170.565 118.443 170.5 118.521 170.466 118.612C170.432 118.704 170.431 118.805 170.462 118.897C170.493 118.99 170.556 119.069 170.638 119.121C170.665 119.141 170.694 119.157 170.724 119.17C170.919 119.255 171.077 119.41 171.166 119.603C171.255 119.797 171.27 120.017 171.208 120.221C171.198 120.252 171.191 120.284 171.189 120.317C171.174 120.414 171.194 120.513 171.244 120.597C171.293 120.681 171.371 120.745 171.463 120.779C171.554 120.813 171.655 120.815 171.748 120.783C171.84 120.752 171.919 120.69 171.972 120.607C171.991 120.581 172.008 120.552 172.021 120.522C172.106 120.326 172.26 120.169 172.454 120.08C172.648 119.99 172.868 119.976 173.072 120.038C173.103 120.048 173.136 120.054 173.168 120.057C173.265 120.071 173.364 120.052 173.448 120.002C173.532 119.952 173.597 119.875 173.631 119.783C173.665 119.692 173.666 119.591 173.635 119.498C173.603 119.406 173.541 119.327 173.458 119.275C173.432 119.255 173.403 119.239 173.373 119.226Z"
        fill="#4D8AF0"
      />
      <path
        opacity="0.5"
        d="M1.42057 56.3744C2.20512 56.3744 2.84113 55.7387 2.84113 54.9546C2.84113 54.1705 2.20512 53.5348 1.42057 53.5348C0.63601 53.5348 0 54.1705 0 54.9546C0 55.7387 0.63601 56.3744 1.42057 56.3744Z"
        fill="#F55F44"
      />
      <path
        opacity="0.5"
        d="M159.938 32.5622C160.723 32.5622 161.359 31.9266 161.359 31.1424C161.359 30.3583 160.723 29.7227 159.938 29.7227C159.154 29.7227 158.518 30.3583 158.518 31.1424C158.518 31.9266 159.154 32.5622 159.938 32.5622Z"
        fill="#F55F44"
      />
      <path
        opacity="0.5"
        d="M95.3268 86.0104C96.2103 86.0104 96.9265 85.2945 96.9265 84.4115C96.9265 83.5285 96.2103 82.8126 95.3268 82.8126C94.4433 82.8126 93.7271 83.5285 93.7271 84.4115C93.7271 85.2945 94.4433 86.0104 95.3268 86.0104Z"
        fill="#F55F44"
      />
      <path
        opacity="0.5"
        d="M95.3268 86.0104C96.2103 86.0104 96.9265 85.2945 96.9265 84.4115C96.9265 83.5285 96.2103 82.8126 95.3268 82.8126C94.4433 82.8126 93.7271 83.5285 93.7271 84.4115C93.7271 85.2945 94.4433 86.0104 95.3268 86.0104Z"
        fill="#F55F44"
      />
      <path
        opacity="0.5"
        d="M177.581 75.2534C178.366 75.2534 179.002 74.6178 179.002 73.8336C179.002 73.0495 178.366 72.4138 177.581 72.4138C176.797 72.4138 176.161 73.0495 176.161 73.8336C176.161 74.6178 176.797 75.2534 177.581 75.2534Z"
        fill="#F55F44"
      />
      <path
        opacity="0.5"
        d="M62.7462 11.6782C63.6297 11.6782 64.346 10.9624 64.346 10.0793C64.346 9.1963 63.6297 8.48047 62.7462 8.48047C61.8627 8.48047 61.1465 9.1963 61.1465 10.0793C61.1465 10.9624 61.8627 11.6782 62.7462 11.6782Z"
        fill="#47E6B1"
      />
      <path
        opacity="0.5"
        d="M153.892 133.894C154.677 133.894 155.313 133.259 155.313 132.474C155.313 131.69 154.677 131.055 153.892 131.055C153.108 131.055 152.472 131.69 152.472 132.474C152.472 133.259 153.108 133.894 153.892 133.894Z"
        fill="#F55F44"
      />
      <path
        d="M65.4183 81.3398C64.5779 84.0664 65.8449 87.2897 68.3042 88.7245C69.3366 89.3256 70.5247 89.6283 71.525 90.2807C73.6985 91.6962 74.556 94.4057 75.262 96.9C76.0726 99.7673 76.8852 102.799 76.1429 105.683C75.6694 107.523 74.5923 109.149 73.9801 110.949C73.4681 112.456 73.2898 114.056 73.4575 115.639C73.5471 116.479 73.7561 117.344 74.332 117.971C75.1639 118.866 76.5034 119 77.7064 119.216C80.2498 119.697 82.6429 120.773 84.6895 122.357C86.7361 123.941 88.378 125.987 89.4805 128.327"
        stroke="url(#mask-icon-balloons)"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M65.6761 81.3398C64.8357 84.0664 66.1027 87.2897 68.562 88.7245C69.5944 89.3256 70.7825 89.6283 71.7829 90.2807C73.9564 91.6962 74.8138 94.4057 75.5198 96.9C76.3304 99.7673 77.1431 102.799 76.4008 105.683C75.9273 107.523 74.8501 109.149 74.2379 110.949C73.7259 112.456 73.5476 114.056 73.7153 115.639C73.8049 116.479 74.014 117.344 74.5899 117.971C75.4217 118.866 76.7612 119 77.9642 119.216C80.5076 119.697 82.9007 120.773 84.9473 122.357C86.994 123.941 88.6358 125.987 89.7383 128.327"
        stroke="#535461"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M97.4888 60.9574C95.4155 63.846 93.2633 66.9521 93.0863 70.5037C92.8154 75.959 97.1816 80.4209 99.1312 85.5244C99.9761 87.7725 100.359 90.1679 100.256 92.5672C100.153 94.9665 99.5663 97.3203 98.5318 99.4878C97.5805 101.453 96.2239 103.406 96.3988 105.583C96.4991 106.911 97.1645 108.12 97.6999 109.341C99.0139 112.402 99.5873 115.73 99.3734 119.055C99.1596 122.379 98.1646 125.606 96.4692 128.474"
        stroke="url(#mask-icon-balloons2)"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M97.7443 60.9574C95.6732 63.8567 93.521 66.9542 93.3397 70.5037C93.0688 75.959 97.435 80.4209 99.3846 85.5244C100.23 87.7725 100.612 90.1679 100.509 92.5672C100.406 94.9665 99.8197 97.3203 98.7852 99.4878C97.8339 101.453 96.4773 103.406 96.6522 105.583C96.7525 106.911 97.4179 108.12 97.9533 109.341C99.2673 112.402 99.8407 115.73 99.6268 119.055C99.413 122.379 98.418 125.606 96.7226 128.474"
        stroke="#535461"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M126.577 86.9414L127.58 95.1084C127.712 96.1935 127.825 97.3767 127.243 98.3061C126.69 99.1823 125.654 99.6001 124.847 100.248C122.2 102.38 122.441 106.454 123.354 109.724C124.267 112.994 125.581 116.508 124.312 119.654C123.787 120.952 122.862 122.046 122.179 123.265C121.008 125.349 120.544 127.756 120.857 130.126"
        stroke="url(#mask-icon-balloons3)"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M126.827 86.9414L127.83 95.1084C127.962 96.1935 128.075 97.3767 127.493 98.3061C126.94 99.1823 125.904 99.6001 125.097 100.248C122.45 102.38 122.691 106.454 123.604 109.724C124.517 112.994 125.831 116.508 124.562 119.654C124.037 120.952 123.112 122.046 122.429 123.265C121.258 125.349 120.794 127.756 121.107 130.126"
        stroke="#535461"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M152.572 53.3725C152.571 49.5517 151.664 45.7856 149.928 42.3818C148.191 38.9781 145.673 36.0333 142.58 33.7882C139.487 31.5431 135.906 30.0612 132.13 29.4639C128.354 28.8665 124.491 29.1705 120.855 30.351C121.055 28.9907 121.158 27.6179 121.164 26.243C121.174 19.968 118.744 13.9346 114.389 9.41535C110.033 4.89607 104.091 2.24422 97.817 2.01913C91.5426 1.79404 85.426 4.01331 80.7573 8.20885C76.0887 12.4044 73.2329 18.2482 72.7923 24.5077C69.1556 23.3246 65.2903 23.0187 61.5126 23.6151C57.7349 24.2114 54.1521 25.693 51.0572 27.9386C47.9623 30.1843 45.4432 33.1303 43.706 36.5356C41.9688 39.9409 41.0627 43.7089 41.062 47.5313C41.062 59.6826 50.0205 76.9503 61.6773 80.0095L63.4925 81.0456L62.507 84.4202H68.3429L67.0759 81.0413L68.8825 80.0095C77.8965 77.6453 85.2873 66.7922 88.1818 56.3826C89.7665 57.4368 91.5109 58.2286 93.3478 58.7276L95.163 59.7636L94.1925 63.1298H100.028L98.7614 59.7509L100.568 58.7191C101.907 58.359 103.196 57.8356 104.407 57.1607C105.967 68.8388 114.262 83.0964 124.758 85.8485L126.573 86.8846L125.588 90.2593H131.424L130.152 86.8803L131.959 85.8485C143.624 82.7894 152.572 65.5153 152.572 53.3725Z"
          fill="url(#mask-icon-balloons4)"
        />
      </g>
      <path
        d="M69.2702 83.1706H63.6221L64.6118 79.7853H67.9989L69.2702 83.1706Z"
        fill="#F55F44"
      />
      <path
        d="M89.7385 47.4753C89.7385 60.4111 79.2463 79.3608 66.3055 79.3608C53.3647 79.3608 42.8726 60.409 42.8726 47.4753C42.8726 41.2636 45.3415 35.3063 49.7362 30.914C54.131 26.5217 60.0915 24.0541 66.3066 24.0541C72.5217 24.0541 78.4822 26.5217 82.8769 30.914C87.2717 35.3063 89.7406 41.2636 89.7406 47.4753H89.7385Z"
        fill="#F55F44"
      />
      <path
        d="M67.9992 79.9246H64.612L62.6348 78.7969H69.9765L67.9992 79.9246Z"
        fill="#535461"
      />
      <path
        opacity="0.1"
        d="M57.8352 29.274C57.8352 29.274 47.9531 34.6356 46.541 45.3586L57.8352 29.274Z"
        fill="white"
      />
      <path
        d="M99.9157 62.5807H94.2676L95.2573 59.1953H98.6445L99.9157 62.5807Z"
        fill="#4D8AF0"
      />
      <path
        d="M120.383 26.8865C120.383 39.8224 109.89 58.7721 96.9496 58.7721C84.0087 58.7721 73.5166 39.8202 73.5166 26.8865C73.5166 20.6748 75.9855 14.7176 80.3803 10.3252C84.775 5.93291 90.7355 3.46533 96.9506 3.46533C103.166 3.46533 109.126 5.93291 113.521 10.3252C117.916 14.7176 120.385 20.6748 120.385 26.8865H120.383Z"
        fill="#F70C00"
      />
      <path
        d="M98.6433 59.337H95.2561L93.2788 58.2072H100.621L98.6433 59.337Z"
        fill="#535461"
      />
      <path
        opacity="0.1"
        d="M88.4807 8.68359C88.4807 8.68359 78.5986 14.0451 77.1865 24.7681L88.4807 8.68359Z"
        fill="white"
      />
      <path
        d="M130.302 88.8367H124.654L125.644 85.4492H129.031L130.302 88.8367Z"
        fill="#3AD29F"
      />
      <path
        d="M150.77 53.136C150.77 66.0719 140.278 85.0216 127.337 85.0216C114.397 85.0216 103.902 66.0719 103.902 53.136C103.902 46.9243 106.371 40.9671 110.766 36.5748C115.161 32.1824 121.121 29.7148 127.336 29.7148C133.551 29.7148 139.512 32.1824 143.907 36.5748C148.301 40.9671 150.77 46.9243 150.77 53.136Z"
        fill="#3AD29F"
      />
      <path
        d="M129.03 85.5881H125.643L123.666 84.4603H131.007L129.03 85.5881Z"
        fill="#535461"
      />
      <path
        opacity="0.1"
        d="M118.867 34.9375C118.867 34.9375 108.985 40.299 107.573 51.022L118.867 34.9375Z"
        fill="white"
      />
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M110.15 92.8239C108.791 91.4617 106.809 90.9202 104.57 91.2975C102.475 91.6514 100.378 92.7898 98.6677 94.4953C98.1722 94.9933 97.7557 95.5641 97.4327 96.1879C97.1182 95.5431 96.7051 94.9512 96.2084 94.4334C94.5276 92.696 92.4501 91.5256 90.3533 91.1419C88.1222 90.7156 86.1322 91.2336 84.7479 92.5724C83.3635 93.9111 82.7962 95.8831 83.1417 98.1257C83.4659 100.223 84.5708 102.336 86.2538 104.069C89.7902 107.717 96.8483 106.293 97.1469 106.229L97.2343 106.21L97.5052 106.271C97.8039 106.34 104.836 107.885 108.435 104.299C110.141 102.594 111.286 100.503 111.649 98.4093C112.044 96.1687 111.508 94.1883 110.15 92.8239ZM95.961 104.123C94.2546 104.353 90.0035 104.664 87.894 102.487C86.5374 101.087 85.6501 99.4155 85.3963 97.7761C85.1659 96.2838 85.4987 95.0048 86.3391 94.1989C86.6671 93.8843 87.0593 93.6443 87.4887 93.4954C88.2827 93.239 89.1303 93.1963 89.9459 93.3718C91.5755 93.6766 93.2222 94.6146 94.5788 96.0152C96.6883 98.1769 96.2446 102.423 95.961 104.12V104.123ZM109.422 98.0234C109.141 99.6564 108.226 101.315 106.843 102.69C104.696 104.822 100.444 104.444 98.7488 104.182C98.4949 102.477 98.1238 98.2366 100.272 96.0962C101.654 94.7212 103.315 93.8109 104.949 93.5381C105.768 93.3767 106.615 93.4341 107.404 93.7044C107.832 93.8609 108.221 94.1082 108.543 94.4292C109.367 95.2542 109.678 96.529 109.422 98.0213V98.0234Z"
          fill="url(#mask-icon-balloons5)"
        />
      </g>
      <path
        d="M97.8402 105.766L97.1683 105.907C96.8825 105.966 90.1295 107.328 86.7445 103.839C85.1362 102.18 84.0782 100.159 83.7583 98.151C83.4255 96.0043 83.9716 94.1176 85.294 92.8364C86.6165 91.5552 88.5212 91.0691 90.6563 91.4678C92.655 91.8409 94.6429 92.9601 96.2512 94.6207C99.6341 98.1105 98.0599 104.815 97.9917 105.099L97.8402 105.766ZM87.9155 93.7232C87.5043 93.8658 87.1288 94.0956 86.8148 94.3969C86.0128 95.175 85.6929 96.3902 85.9126 97.8206C86.1558 99.3875 87.0047 100.988 88.3037 102.329C90.3236 104.412 94.3912 104.114 96.0229 103.894C96.2938 102.272 96.7204 98.2171 94.7005 96.1343C93.4015 94.7955 91.8274 93.8959 90.266 93.606C89.4858 93.4379 88.675 93.4783 87.9155 93.7232Z"
        fill="#F70C00"
      />
      <path
        d="M96.8419 105.795L96.6926 105.126C96.6286 104.84 95.1697 98.1102 98.6123 94.6801C100.25 93.0492 102.255 91.9641 104.26 91.6252C106.393 91.2628 108.298 91.7808 109.593 93.0855C110.888 94.3901 111.406 96.2832 111.037 98.415C110.691 100.417 109.599 102.419 107.961 104.049C104.519 107.479 97.789 106 97.5095 105.936L96.8419 105.795ZM106.974 93.9147C106.219 93.6563 105.41 93.6012 104.627 93.7548C103.062 94.0192 101.473 94.8911 100.148 96.2064C98.0918 98.2551 98.4417 102.314 98.6912 103.943C100.319 104.19 104.382 104.559 106.436 102.512C107.759 101.195 108.633 99.6088 108.904 98.0355C109.149 96.6094 108.851 95.3878 108.061 94.5969C107.752 94.2941 107.381 94.0614 106.974 93.9147Z"
        fill="#F70C00"
      />
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M129.776 104.003H64.2915V117.099H67.6936V155H126.374V117.099H129.776V104.003Z"
          fill="url(#mask-icon-balloons6)"
        />
      </g>
      <path
        d="M125.633 107.962H68.437V154.356H125.633V107.962Z"
        fill="#EEEEEE"
      />
      <path
        d="M102.421 116.246H91.6455V154.354H102.421V116.246Z"
        fill="#F70C00"
      />
      <path
        opacity="0.1"
        d="M125.633 105.476H68.437V117.075H125.633V105.476Z"
        fill="black"
      />
      <path
        d="M128.949 104.648H65.1221V116.248H128.949V104.648Z"
        fill="#EEEEEE"
      />
      <path
        d="M102.421 104.648H91.6455V116.248H102.421V104.648Z"
        fill="#F70C00"
      />
    </g>
    <defs>
      <linearGradient
        id="mask-icon-balloons"
        x1="64.9448"
        y1="104.839"
        x2="89.6725"
        y2="104.839"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="mask-icon-balloons2"
        x1="4525.07"
        y1="35893.4"
        x2="4782.39"
        y2="35893.4"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="mask-icon-balloons3"
        x1="5282.81"
        y1="25805.7"
        x2="5521.99"
        y2="25805.7"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="mask-icon-balloons4"
        x1="70774.3"
        y1="44999.2"
        x2="70774.3"
        y2="8476.32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="mask-icon-balloons5"
        x1="18388.9"
        y1="9282.39"
        x2="18388.9"
        y2="8131.53"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="mask-icon-balloons6"
        x1="29854.6"
        y1="37183.1"
        x2="29854.6"
        y2="24983.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <clipPath id="mask-icon-balloons7">
        <rect width="179" height="155" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
